import GiftDetails from "./GiftDetails";

export default GiftDetails;
